import { AutoCompleteMulti, ISelectType, useFetch } from "@4uhub/lib4uhub";
import { Grid } from "@mui/material";
import { useCallback, useEffect, useState } from "react";
import { useTranslation } from "react-i18next";
import { calendarSpecialtyConsultationWebList } from "../../../../../../../services/calendarSpecialtyConsultationWeb.service";

const translationPath =
  "chatBot.page.automations.automationReceivedRules.ticketAutRecRuleUnchosenProfessionalRule.";

export const UnchosenProfessionalSpecialty = () => {
  const { t } = useTranslation();

  const { sendRequest: calendarSpecialtyConsultationWebListRequest } = useFetch(
    calendarSpecialtyConsultationWebList,
  );

  const [specialtyOptions, setSpecialtyOptions] = useState<ISelectType[]>();

  const fetchcalendarSpecialtyConsultationWebList = useCallback(async () => {
    const { data, success } =
      await calendarSpecialtyConsultationWebListRequest(null);
    if (data && success) {
      const newData = data.map((item) => ({
        id: item.identifier.toString(),
        name: item.name,
      }));
      setSpecialtyOptions(newData);
    }
  }, [calendarSpecialtyConsultationWebListRequest]);

  useEffect(() => {
    fetchcalendarSpecialtyConsultationWebList();
  }, [fetchcalendarSpecialtyConsultationWebList]);

  return (
    <Grid item xs={12}>
      <AutoCompleteMulti
        name="specialtyRequests"
        label={t(translationPath + "specialties")}
        getOptionLabel={({ name }) => name}
        options={specialtyOptions}
        size="small"
        fullWidth
        keepOpenOnSelect
      />
    </Grid>
  );
};
